export default __webpack_public_path__ + "static/media/style12.7cba5917.jpeg";